<ion-content class="bajaj-prime-content">
  <div class="bajaj-prime-container">
    <div class="prime-card">
      <!-- Top Section - Prime Membership Promotion -->
      <div class="prime-promotion-section">
        <!-- Branding Section -->
        <div class="branding-section">
          <div class="bajaj-logo-container">
            <div class="bajaj-logo-box">
              <img src="https://img.travelx.ai/bfl/bajaj_prime.png" alt="Bajaj Finance Prime" class="bajaj-logo-img">
            </div>
          </div>
        </div>

        <!-- Promotional Text -->
        <div class="promotional-text" *ngIf="isPrimeEnabled" >
          <h2 class="prime-title">You got</h2>
          <h2 class="prime-title">Prime member</h2>
          <div class="prime-title">Privilage Discount</div>
        </div>

        <div class="promotional-text" *ngIf="!isPrimeEnabled" >
          <h2 class="prime-title">Become Prime </h2>
          <h2 class="prime-title">member & save </h2>
          <h2 class="prime-title">additional </h2>
          <div class="savings-amount">₹500</div>
        </div>

        <!-- 3D Gift Boxes -->
        <div class="gift-boxes-container">
          <img src="https://img.travelx.ai/bfl/3d-gift.png" alt="3D Gift Boxes" class="gift-boxes-image">
        </div>
      </div>

      <!-- Bottom Section - Membership Status and Actions -->
      <div class="membership-section">
        <h5 class="section-title" *ngIf="isPrimeEnabled">
          Congratulations!
        </h5>
        <!-- Status Message -->
        <div class="status-message" *ngIf="isPrimeEnabled">
          <p class="status-text">You are saving ₹500 extra on your booking as prime membership benefit</p>
        </div>
        <div class="status-message" *ngIf="!isPrimeEnabled">
          <p class="status-text">We couldn't find prime membership</p>
          <p class="status-text">associated with your number</p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons" *ngIf="!isPrimeEnabled">
          <ion-button class="primary-btn join-prime-btn" expand="block" (click)="onJoinPrime()" >
            <span class="btn-text">Join Prime Now</span>
            <ion-icon name="arrow-forward" class="arrow-icon"></ion-icon>
          </ion-button>
          
          <button class="continue-booking-btn" (click)="onContinueBooking()">
            <span class="btn-text">Continue Booking</span>
            <ion-icon name="arrow-forward" class="arrow-icon"></ion-icon>
          </button>
        </div>

        <div class="action-buttons" *ngIf="isPrimeEnabled">
          <ion-button class="primary-btn join-prime-btn" (click)="onContinueBooking()">
            <span class="btn-text">Continue Booking</span>
            <ion-icon name="arrow-forward" class="arrow-icon"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</ion-content>
